(ns frontend.view.modals.curtains.put-on-hold-curtain.events
  (:require
   [clojure.string :as string]
   [potpuri.core :as potpuri :refer [fn-> fn->>]]
   [frontend.utils :as fu]
   [common.localization :as loc]
   [common.entity :as entity]
   [common.util :as cu]
   [frontend.actions.deal :as deal-actions]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.state.current-session :as session]
   [frontend.logging :as logging]
   [frontend.view.modals.email-editor.view :as email-editor-modal]
   [frontend.actions.email :as actions-email]))

(defn put-on-hold!
  [state deal close-modal!]
  (let [edits (:edit @state)
        {:keys [months until internal-comment send-notification notify-to
                subject message footer save-default]}
        edits
        until (if (zero? months)
                until
                months)
        msg {:oppo-id           (:db/id deal)
             :until             until
             :status-comment    internal-comment
             :send-notification send-notification
             :notify-to         notify-to
             :subject           subject
             :message           message
             :email-footer      footer
             :save-default      save-default}
        on-success! (fn [] (close-modal!))
        on-error! (fn [e]
                    (logging/error "put-on-hold failed" e))]
    (deal-actions/*->put-on-hold msg on-success! on-error!)))

(defn nylas-put-on-hold!
  [state {:keys [oppo close!]}]
  (let [edits (:edit @state)
        {:keys [months until internal-comment]} edits
        until (if (zero? months)
                until
                months)
        email-targets (fu/resolve-contact-persons oppo)
        email-subject (loc/tr :put-on-hold-curtain/default-subject [(:oppo/name oppo)])
        message (or (:tenant/put-on-hold-template @session/tenant)
                    (loc/tr :put-on-hold-curtain/default-message))
        message (if (string/includes? message "<p>")
                  message
                  (str "<p>"
                       (->> message
                            (string/split-lines)
                            (remove empty?)
                            (string/join "</p><p><br></p><p>"))
                       "</p>"))]
    (modals/open-modal!
     email-editor-modal/modal-key
     {:title-text (loc/tr :put-on-hold-and-notify)
      :cancel-text (loc/tr :cancel)
      :primary-button-text (loc/tr :confirm)
      :on-primary-submit! (fn [email success! failure!]
                            (let [data (merge {:oppo-id        (:db/id oppo)
                                               :status-comment (or internal-comment "")
                                               :until          until
                                               :send-notification false})
                                  on-success! (fn [args]
                                                (actions-email/*->send-email
                                                 email
                                                 (fn [args]
                                                   (success! args)
                                                   (close!))
                                                 failure!))
                                  on-error! (partial logging/error "put on hold error !")]
                              (deal-actions/*->put-on-hold data on-success! on-error!)))
      :related-entities #{(:db/id oppo)}
      :to (some->> email-targets
                   (map :person/universal-email-address))
      :subject email-subject
      :body message})))

(defn on-put-on-hold
  [state deal close-modal!]
  (let [edits (:edit @state)
        notify? (:send-notification edits)]
    (if (and notify?
             (session/nylas-active?))
      (nylas-put-on-hold! state
                          {:oppo         deal
                           :put-on-hold! put-on-hold!
                           :close!       close-modal!})
      (let [{:keys [notify-to subject message footer]} edits
            contact (get @session/entities notify-to)
            email (:person/universal-email-address contact)
            tenant-name (entity/display-string @session/tenant)
            sender-email (if (some #{tenant-name} ["Teollisuussijoitus" "Tesi" "TeSi"])
                           (let [pipeline-id (:oppo/pipeline deal)
                                 pipeline (get @session/entities pipeline-id)]
                             (if (= (:pipeline/name pipeline) "Venture")
                               "venturebridge@tesi.fi"
                               "vakautus@tesi.fi"))
                           "admin@zapflow.com")
            ending-note (loc/tr :pass-curtain/email-ending-note [tenant-name])
            full-email (if (string/blank? footer)
                         message
                         (str message "\n\n" footer))

            confirm-text (if notify?
                           (loc/tr :put-on-hold-curtain/confirm-notify)
                           (loc/tr :put-on-hold-curtain/confirm-no-notify))]
        (modals/open-modal!
         confirmation-modal/modal-key
         {:body           (if notify?
                            [:div.kpi-email-template-preview
                             [:div.kpi-email-template-top
                              [:span.label (loc/tr :email/from) ":"] " "
                              [:span.email-text sender-email]]
                             [:div.kpi-email-template-top
                              [:span.label (loc/tr :email/to) ":"] " " [:span.email-text email]]
                             [:div.kpi-email-template-top.mt-3
                              [:span.label (loc/tr :sub) ":"] " " [:span.email-text subject]]

                             [:div.kpi-email-full-preview.preview.preview-textarea
                              full-email
                              "\n\n"
                              [:span.kpi-email-preview-ending-note
                               ending-note]]]
                            [:div.text-center
                             [:p confirm-text]])
          :confirm-text   (if notify?
                            (loc/tr :put-on-hold-curtain/put-on-hold-and-notify)
                            (loc/tr :confirm))
          :confirm-icon   ""
          :skip-checkbox? (not notify?)
          :checkbox-text  (when notify?
                            (loc/tr :pass-curtain/confirm-sending))
          :on-confirm     #(put-on-hold! state deal close-modal!)})))))
